import WINDOW from "../../../../utils/window";
import getAxisValue from "./get-axis-value";
import getPointerContinuousPercents from "./get-pointer-continuous-percents";

/**
 *
 * @param {MainClassProps} _main
 * @param {TriggerProps} trigger
 * @returns
 */
const getPointerContinuous = (_main, trigger) => {
  const axis = getAxisValue(trigger);
  const pointer = /** @type {Map<"x" | "y", any>} */ (WINDOW.get("pointer"));

  switch (axis) {
    /**
     * X
     */
    case "x":
      return getPointerContinuousPercents(
        pointer,
        "x",
        /** @type {Number} */ (WINDOW.get("width"))
      );

    /**
     * Y
     */
    case "y":
      return getPointerContinuousPercents(
        pointer,
        "y",
        /** @type {Number} */ (WINDOW.get("height"))
      );

    /**
     * Both
     */
    default: {
      let x = getPointerContinuousPercents(
        pointer,
        "x",
        /** @type {Number} */ (WINDOW.get("width"))
      );
      let y = getPointerContinuousPercents(
        pointer,
        "y",
        /** @type {Number} */ (WINDOW.get("height"))
      );

      return (x + y) / 2;
    }
  }
};

export default getPointerContinuous;
